import api from "app/lib/api";
import { AVAILABILITY_FLAG } from "static/account_document";
import endpoints from "static/endpoints";
import { interpolate } from "utils/string";

export const fetchAccountDocumentAvailability = async (accountId) => {
  const data = await api.get(
    interpolate(endpoints.accountDocuments.availability, { accountId })
  );

  return Object.fromEntries(
    Object.values(AVAILABILITY_FLAG).map((flag) => [
      flag,
      data?.[flag] === true,
    ])
  );
};

export const fetchAccountDocumentPdf = async (accountId, documentType) => {
  return await api(
    interpolate(endpoints.accountDocuments.document, {
      accountId,
      documentType,
    }),
    {
      method: "GET",
      responseType: "blob",
    }
  );
};
